//!REVISAR
// import "./style.css";
import { parse, format } from "date-fns";

export const tableData = (data) => {
  const columns = [
    // {
    //   field: "estado",
    //   headerName: "Estado",
    //   minWidth: 150,
    //   flex: 0.5,
    //   sortable: false,
    //   renderCell: (params) => {
    //     return <BadgeEstadoActa estado={params.row.estado} />;
    //   },
    // },

    {
      field: "fecha",
      headerName: "Fecha",
      headerClassName: "custom-header",
      minWidth: 90,
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        return <span>{params.row.fecha.split(" ")[0]}</span>;
        // return <BadgeEstadoActa estado={params.row.estado} />;
      },
    },
    {
      field: "solicitante",
      headerName: "Solicitante",
      headerClassName: "custom-header",
      minWidth: 200,
      flex: 0.5,
      sortable: false,
    },
    {
      field: "dni",
      headerName: "Documento",
      headerClassName: "custom-header",
      minWidth: 100,
      flex: 0.5,
      sortable: false,
    },
    {
      field: "barrio",
      headerName: "Barrio",
      headerClassName: "custom-header",
      minWidth: 150,
      flex: 0.5,
      sortable: false,
    },
    {
      field: "lugar",
      headerName: "Lugar",
      headerClassName: "custom-header",
      minWidth: 150,
      flex: 0.5,
      sortable: false,
    },

    {
      field: "tipo",
      headerName: "Tipo solicitud",
      minWidth: 235,
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return (
          <div>
            <div className="m-0">
              {params.row.tipo.map((tipo, index) => {
                return (
                  <div key={index} style={{ lineHeight: "13px" }}>
                    <span style={{ fontSize: "12px" }} className="fw-bold">
                      {tipo.nombre}
                    </span>{" "}
                    <span
                      style={{ fontSize: "11px" }}
                    >{` | ${tipo.cantidad_arboles} árboles`}</span>
                  </div>
                );
              })}
            </div>
          </div>
        );
      },
    },

    // {
    //   field: "descripcion",
    //   headerName: "Descripcion",
    //   headerClassName: "custom-header",
    //   minWidth: 200,
    //   flex: 0.5,
    //   sortable: false,
    // },
    {
      field: "telefono",
      headerName: "Telefono",
      headerClassName: "custom-header",
      minWidth: 105,
      flex: 0.5,
      sortable: false,
    },
    {
      field: "inspector",
      headerName: "Inspector",
      headerClassName: "custom-header",
      minWidth: 200,
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        return (
          <div>
            <div className="m-0">
              {params.row.inspector ? (
                <div style={{ lineHeight: "13px" }}>
                  <span style={{ fontSize: "12px" }} className="fw-bold">
                    {params.row.inspector.nombre}
                  </span>
                </div>
              ) : (
                <div style={{ lineHeight: "13px" }}>
                  <span style={{ fontSize: "12px" }} className=" text-danger">
                    No tiene inspector asignado
                  </span>
                </div>
              )}
            </div>
          </div>
        );
      },
    },
    {
      field: "fecha_asignacion",
      headerName: "Fecha asignado",
      headerClassName: "custom-header",
      minWidth: 200,
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        return (
          <div>
            {params?.row?.fecha_asignacion ? (
              format(
                parse(params?.row?.fecha_asignacion, "yyyy-MM-dd HH:mm:ss", new Date()),
                "dd/MM/yyyy HH:mm"
              )
            ) : (
              <p className="text-danger m-0">no tiene</p>
            )}
          </div>
        );
      },
    },

    // {
    //   field: "ciudadano",
    //   headerName: "Ciudadano",
    //   headerClassName: "custom-header",
    //   minWidth: 230,
    //   flex: 1,
    //   sortable: false,
    // },
    // {
    //   field: "dni",
    //   headerName: "DNI",
    //   headerClassName: "custom-header",
    //   minWidth: 80,
    //   flex: 1,
    //   sortable: false,
    // },
    // ...(estado_id === 8 || estado_id == 4 || estado_id == 11
    //   ? [
    //       {
    //         field: "notificador_nombre",
    //         headerName: "Notificador",
    //         minWidth: 300,
    //         flex: 2,
    //         sortable: false,
    //         renderHeader: () => {
    //           return (
    //             <HeaderColumn
    //               label={"Notificador"}
    //               color={"#FFF"}
    //               setFiltersField={setFiltersField}
    //               setOrder={setOrder}
    //               setOrderField={setOrderField}
    //               typeInput={"text"}
    //               field={"notificador"}
    //               place={"Notificador"}
    //             />
    //           );
    //         },
    //         renderCell: (params) => {
    //           return (
    //             <>
    //               <span
    //                 className={`${params.row.tipo_acta_generada == "DIGITAL" ? "  px-2 rounded fw-bold" : params.row.notificador_nombre ? "" : "text-danger"}`}
    //               >
    //                 {params.row.tipo_acta_generada == "DIGITAL"
    //                   ? "Mi Muni Digital"
    //                   : params.row.notificador_nombre
    //                     ? params.row.notificador_nombre
    //                     : "No tiene notificador"}
    //               </span>
    //             </>
    //           );
    //         },
    //       },
    //     ]
    //   : []),
  ];

  const rows =
    data?.map((d, index) => {
      return {
        id: d?.id,
        estado: d?.estado,
        direccion: d?.direccion,
        fecha: d?.fecha_solicitud,
        solicitante: d?.solicitante,
        dni: d?.dni,
        barrio: d?.barrio,
        lugar: d?.lugar,
        tipo: d?.tipos_solicitud,
        descripcion: d?.descripcion,
        telefono: d?.telefono,
        inspector: d?.inspector,
        fecha_asignacion: d?.fecha_asignacion,

        // barrio: d?.barrio?.nombre,
        // barrio: d?.barrio_original?.descripcion,
        // direccion: d?.barrio?.direccion,

        // estado: d?.estado?.estado,
        // estado_id: d?.estado_id,
        // ciudadano: d?.nombre_ciudadano,

        // fecha_hora: d?.fecha_hora,
        // numero_acta: d?.numero_acta,
        // infraccion: d?.tipo,
        // plate: d?.plate,
        // localidad: d?.localidad,
        // documento: d?.documento_titular,
        // get_acta_fisica: d.get_acta_fisica,
        // estado_id: d.estado_id,
        // zona: d.zona,
        // user_id_asignado: estado_id == 8 ? d?.notificadores[0]?.user_id_asignado : null,
        // notificador_nombre:
        //   estado_id == 8 || estado_id == 4 || estado_id == 11
        //     ? d?.notificadores[0]?.persona?.nombre
        //     : null,
        // estado: d?.estado?.id,
        // alertas: d?.alertas,
        // motivo: estado_id == 12 ? d?.motivo?.nombre : null,
        // tipo_acta_generada:
        //   estado_id == 8 || estado_id == 4 || estado_id == 11 ? d.tipo_acta_generada : null,
        // dependencia: d?.dependencia,
        // domicilio_notificacion_id: d?.domicilio_notificacion_id,
      };
    }) || [];

  const filter = (d, value) => {
    value = value.toLowerCase();

    return (
      String(d.id)?.toString().toLowerCase().includes(value) ||
      String(d.plate)?.toString().toLowerCase().includes(value) ||
      String(d.fecha_hora)?.toString().toLowerCase().includes(value) ||
      String(d.infraccion)?.toString().toLowerCase().includes(value) ||
      String(d.documento)?.toString().toLowerCase().includes(value) ||
      String(d.localidad)?.toString().toLowerCase().includes(value) ||
      String(d.numero_acta)?.toString().toLowerCase().includes(value) ||
      String(d.numero_acta)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
